import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Modal, Row, Nav, Form } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import DatePicker from "react-datepicker";
import { PacmanLoader } from 'react-spinners';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class OwnerList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            owners: [],
            filter: {}
        };

        
        
        this.deleteOwner = this.deleteOwner.bind(this);
        this.handleDeleteOwner = this.handleDeleteOwner.bind(this);
    }
    

    async componentDidMount() {
        console.log("In OwnerList componentDidMount");
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        if(Object.keys(this.props.filter)>0){
            try {
                this.setState({ isLoading: true });      
                const owners = await this.getOwners(this.props.filter);
                this.setState({ owners });
            } catch (e) {
                alert(e);
            }
        }

        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {
        source.cancel();
        this.setState({ Owner: [] });
        this.setState({ suburbOptions: [] });
        this.setState({ owners: [] });        
    }


    async componentDidUpdate(prevProps) {
        


        if (prevProps.filter !== this.props.filter) {
            this.setState({ isLoading: true });      
            const owners = await this.getOwners(this.props.filter);
            console.log(owners);
            this.setState({ owners });
            this.setState({ isLoading: false });     
        }
    }


    async getOwners(filter) {
        console.log("Inside getOwners() ");
        console.log(filter);
        const response =  API.get("colin", "/owners", {'queryStringParameters': filter});
        try {
            return await response;

        } catch (error) {
            alert(error+". Please refresh the page (F5) to try again.")
        };
      
    }

    

    deleteOwner(propertyKey) {
        return API.del("colin", "/owner", { 'queryStringParameters': propertyKey });

    };

    handleAddOwnerToProperty = async owner => {
        
        console.log("Inside handleAddOwnerToPropertyAndSale");
        console.log(owner);
        const ownerid = owner.original.owner_id;

        
        for (var i = 0; i < this.props.properties.length;i++) {
            const confirmed = window.confirm(
                "Link this owner to property " + this.props.properties[i].property_key + "?"
            );

            if (!confirmed) {
                continue;
            }
            {
                let property_owner = {
                    property_key: this.props.properties[i].property_key,
                    owner_id: ownerid,
                    registered_owner: true,
                    share: 100,
                    owner_preamble: null,
                    owner_postamble: null,
                    sort_order: 1,
                    suppress_address: false,
                    suppress_text: false,
                    use_alternate_text: false,
                    created_by: this.props.user,
                    last_edited_by: this.props.user
                }
                //return
                // const result =  await this.props.saveRecord(property_owner, "propertyOwners", "property_owner_id");
                // console.log(result);
                // if (result.result) {
                //     property_owner["property_owner_id"] = result.id;
                //     property_owner.new_record = false;
                
                //     propertyOwners.push(property_owner);
                //     this.props.updateTableState(propertyOwners, "propertyOwners");
                // }
                // else {
                //     this.setState({ errorMessage: result.error_message });
                //     this.setState({ showAlert: true });
                // }

                await API.post("colin", `/propertyowners/new`, { body: property_owner }).then(response => {
                    return response;
                }).catch(error => {
                    console.log(error)
                });
            }
        }

    }

    

    //This function is a bit of a hack. The solution probably needs to be reengineered a bit but the project is too close to the delivery date to change at this stage
    handleAddOwnerToPropertyAndSale = async owner => {
        
        console.log("Inside handleAddOwnerToPropertyAndSale");
        console.log(owner);
        const ownerid = owner.original.owner_id;

        let confirmed = window.confirm(
            "Link the selected Owner to this Sale?"
        );

        if (confirmed) {
        
            // for (var i = 0; i < this.props.properties.length;i++) {
            
            //     let property_owner = {
            //         property_key: this.props.properties[i].property_key,
            //         owner_id: ownerid,
            //         registered_owner: true,
            //         share: 100,
            //         owner_preamble: null,
            //         owner_postamble: null,
            //         sort_order: 1,
            //         suppress_address: false,
            //         suppress_text: false,
            //         use_alternate_text: false,
            //         created_by: this.props.user,
            //         last_edited_by: this.props.user
            //     }
            //     //return
            //     await API.post("colin", `/propertyowners/new`, { body: property_owner }).then(response => {
            //         return response;
            //     }).catch(error => {
            //         console.log(error)
            //     });
            // }

            let buyerSellers = [...this.props.buyerSellers];
        
            //Add owner as buyer
            let buyer_seller = {
                                    sale_id: this.props.saleid,
                                    owner_id: ownerid,     
                                    owner_name: owner.original.owner_name,
                                    buyer_vendor: false,     
                                    share: 100,      
                                    created_by: this.props.user,
                                    last_edited_by: this.props.user,
                                    new_record: true
                                }
            
            
            const result =  await this.props.saveRecord(buyer_seller, "buyerSellers", "buyer_seller_id");
            console.log(result);
            if (result.result) {
                buyer_seller["buyer_seller_id"] = result.id;
                buyer_seller.new_record = false;
               
                buyerSellers.push(buyer_seller);
                this.props.updateTableState(buyerSellers, "buyerSellers");
            }
            else {
                this.setState({ errorMessage: result.error_message });
                this.setState({ showAlert: true });
            }
    
        }
        
        // confirmed = window.confirm(
        //     "Add the current Property Owners to this Sale as Vendors?"
        // );

        // if (confirmed) {
                  
        //     //back end handles the blank body and grabs all owners against a sale id
        //     await API.post("colin", `/sales/${this.props.saleid}/buyersellers/fromproperty`, { body: {created_by: this.props.user, last_edited_by: this.props.user, buyer_vendor: true} }).then(response => {
        //         return response;
        //     }).catch(error => {
        //         console.log(error)
        //     });
        // }
        this.props.refreshDataSet("buyerSellers");
        //Need to force refresh of buyers sellers here as the list doesnt update

        // confirmed = window.confirm(
        //     "Remove the current Property Owners from the Properties linked to this Sale?"
        // );
        // if (confirmed) {
          
        
        //     for (var i = 0; i < this.props.properties.length;i++) {
        //             console.log(this.props.properties[i].property_id);
        //             await API.del("colin", `/property/${ this.props.properties[i].property_id}/propertyowners`, { body: {created_by: this.props.user, last_edited_by: this.props.user} }).then(response => {
        //                 return response;
        //             }).catch(error => {
        //                 console.log(error)
        //             });
        //     }
        // }
          

    }

    handleAddOwnerToOwner = async ownerid => {
        
        console.log("Inside handleAddOwnerToOwner");
        console.log(this.props.ownerid);
        console.log(ownerid);
        if(this.props.ownerid) {
            if (this.props.ownerid === ownerid) {
                alert('ERROR: you cannot make an owner a parent of itself.');
                return;
            }
            
            let owner_tree = {
                owner_id_child: this.props.ownerid,
                owner_id_parent: ownerid,  
                sort_within: 99,               
                created_by: this.props.user,
                last_edited_by: this.props.user
            }
            return await API.post("colin", `/owners/${this.props.ownerid}/tree/new`, { body: owner_tree }).then(response => {
                if (response.result == false && response.error_message == 'Circular Dependency') {
                    alert('ERROR: adding this owner as a parent would introduce a circular dependency.');
                    return;
                }
                alert("Owner added as parent");
                return response;
            }).catch(error => {
                console.log(error)
            });
            
        }

    }

    handleDeleteOwner = async event => {
        
    
        var r = window.confirm("Are you sure you want to delete this owner?");
        if (r === true) {

            //Delete property
            await this.deleteOwner(event);

            //New search for sales using the existing filters
            this.setState({ isLoading: true });
     
            let owners = await this.getOwners(this.props.filter);               
            this.setState({ owners });
            this.setState({ isLoading: false });
            
            
        };
    };

    selectAll = event =>{
        let owners = [...this.state.owners];
        for(var i=0;i<owners.length;i++){
            owners[i].selected=true;
        }
        this.setState({owners});
    }

    deselectAll = event =>{
        let owners = [...this.state.owners];
        for(var i=0;i<owners.length;i++){
            owners[i].selected=false;
        }
        this.setState({owners});
    }

    handleCheckboxChange = (cellInfo, event) => {
        let owners = [...this.state.owners];
        owners[cellInfo.index][cellInfo.column.id] = event.target.checked;
        owners[cellInfo.index].modified = true;
        this.setState({owners});
    };
    renderEditable = cellInfo => {
        const cellValue = this.state.owners[cellInfo.index][cellInfo.column.id];


        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        // onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                // onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    // onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    // onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }

        }
    }
    renderTable(data) {
        const columns = [
            {
                id: 'selected',
                Header: '',
                maxWidth: 60,
                accessor: 'selected',
                Cell: this.renderEditable,
                style: { textAlign: "center" }
            },
            {
                id: 'owner_id',
                Header: 'Owner ID',
                maxWidth: 60,
                accessor: 'owner_id' ,
                // Cell: e => <a target="_blank" href={`../owners/${e.value}`}>{e.value} </a>
                Cell: e => <LinkContainer to={ {pathname: `../owners/${e.value}`, state: {data: this.state.owners.filter((a) => { if(a.selected){return true;}else{return false;}} ).map(a => a.owner_id)}}}><a>{e.value}</a></LinkContainer>,

        }, {
                id: 'owner_name',
                Header: 'Owner Name',
            
                accessor: 'owner_name'

            }, {
                id: 'owner_index_name',
                Header: 'Index Name',
            
                accessor: 'owner_index_name'

            },
            {
                id: 'property_count',
                Header: 'Owned Properties',
                maxWidth: 120,
                accessor: 'property_count'

            }, {
                id: 'address_line_1',
                Header: 'Address Line 1',
                maxWidth: 200,
                accessor: 'address_line_1'

            },
            {
                id: 'address_line_2',
                Header: 'Address Line 2',
                maxWidth: 200,
                accessor: 'address_line_2'

            },
            {
                id: 'suburb',
                Header: 'Suburb',
                maxWidth: 150,
                accessor: 'suburb'

            },
            {
                id: 'postcode',
                Header: 'Postcode',
                maxWidth: 60,
                accessor: 'postcode'

            },
            {
                id: 'state',
                Header: 'State',
                maxWidth: 60,
                accessor: 'state'

            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={20}
                    sortable={true}
                    className="striped-highlight"
                />
            )
        }
    }


    renderTable1(data) {
        const columns = [

            {
                id: 'owner_id',
                Header: 'Owner ID',
                maxWidth: 60,
                accessor: 'owner_id' ,
                Cell: e => <a target="_blank" href={`../owners/${e.value}`}> {e.value} </a>

        }, {
                id: 'owner_name',
                Header: 'Owner Name',
            
                accessor: 'owner_name'

            }, {
                id: 'owner_index_name',
                Header: 'Index Name',
            
                accessor: 'owner_index_name'

            },
            {
                id: 'property_count',
                Header: 'Owned Properties',
                maxWidth: 120,
                accessor: 'property_count'

            }, {
                id: 'address_line_1',
                Header: 'Address Line 1',
                maxWidth: 200,
                accessor: 'address_line_1'

            },
            {
                id: 'address_line_2',
                Header: 'Address Line 2',
                maxWidth: 200,
                accessor: 'address_line_2'

            },
            {
                id: 'suburb',
                Header: 'Suburb',
                maxWidth: 150,
                accessor: 'suburb'

            },
            {
                id: 'postcode',
                Header: 'Postcode',
                maxWidth: 60,
                accessor: 'postcode'

            },
            {
                id: 'state',
                Header: 'State',
                maxWidth: 60,
                accessor: 'state'

            }
            ,
            {
                Header: '',
                accessor: 'owner_id',
                maxWidth: 180,
                Cell: row => <Button type="button" size="sm" variant="primary" onClick={(e) => this.handleAddOwnerToPropertyAndSale(row,e)}>Add to Sale</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                />
            )
        }
    }

    renderTable2(data) {
        const columns = [

            {
                id: 'owner_id',
                Header: 'Owner ID',
                maxWidth: 60,
                accessor: 'owner_id',
                Cell: e => <a target="_blank" href={`../owners/${e.value}`}> {e.value} </a>

            }, {
                id: 'owner_name',
                Header: 'Owner Name',

                accessor: 'owner_name'

            }, {
                id: 'owner__index_name',
                Header: 'Owner Index Name',

                accessor: 'owner_index_name'

            },
            {
                id: 'property_count',
                Header: 'Owned Properties',
                maxWidth: 120,
                accessor: 'property_count'

            }, {
                id: 'address_line_1',
                Header: 'Address Line 1',
                maxWidth: 200,
                accessor: 'address_line_1'

            },
            {
                id: 'address_line_2',
                Header: 'Address Line 2',
                maxWidth: 200,
                accessor: 'address_line_2'

            },
            {
                id: 'suburb',
                Header: 'Suburb',
                maxWidth: 150,
                accessor: 'suburb'

            },
            {
                id: 'postcode',
                Header: 'Postcode',
                maxWidth: 60,
                accessor: 'postcode'

            },
            {
                id: 'state',
                Header: 'State',
                maxWidth: 60,
                accessor: 'state'

            }
            ,
            {
                Header: '',
                accessor: 'owner_id',
                maxWidth: 140,
                Cell: row => <Button type="button" size="sm" variant="primary" onClick={(e) => this.handleAddOwnerToProperty(row, e)}>Add to Property</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                />
            )
        }
    }

    renderTable3(data) {
        const columns = [

            {
                id: 'owner_id',
                Header: 'Owner ID',
                maxWidth: 60,
                accessor: 'owner_id',
                Cell: e => <LinkContainer to={`../owners/${e.value}`}><a> {e.value} </a></LinkContainer>

            }, {
                id: 'owner_name',
                Header: 'Owner Name',

                accessor: 'owner_name'

            }, {
                id: 'owner_index_name',
                Header: 'Index Name',
            
                accessor: 'owner_index_name'

            },
            {
                id: 'property_count',
                Header: 'Owned Properties',
                maxWidth: 120,
                accessor: 'property_count'

            }, {
                id: 'address_line_1',
                Header: 'Address Line 1',
                maxWidth: 200,
                accessor: 'address_line_1'

            },
            {
                id: 'address_line_2',
                Header: 'Address Line 2',
                maxWidth: 200,
                accessor: 'address_line_2'

            },
            {
                id: 'suburb',
                Header: 'Suburb',
                maxWidth: 150,
                accessor: 'suburb'

            },
            {
                id: 'postcode',
                Header: 'Postcode',
                maxWidth: 60,
                accessor: 'postcode'

            },
            {
                id: 'state',
                Header: 'State',
                maxWidth: 60,
                accessor: 'state'

            }
            ,
            {
                Header: '',
                accessor: 'owner_id',
                maxWidth: 120,
                Cell: row => <Button type="button" size="sm" variant="primary" onClick={(e) => this.handleAddOwnerToOwner(row.value, e)}>Add as Parent</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                />
            )
        }
    }

    
    renderOwners() {
        return (
            <div className="owners">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                <Row >
                {this.props.controlType==="table" && 
                <Col>
                <Nav className="justify-content-start"  >
                             <Nav.Item  >
                            <Button variant="primary" type="button" size="sm" onClick={this.selectAll}>Select All</Button>{" "}
                           </Nav.Item> <Nav.Item  >
                             <Button variant="primary" type="button" size="sm" onClick={this.deselectAll}>Deselect All</Button>{" "}
                             </Nav.Item>
                             </Nav>
                    </Col>}
                    <Col className="text-right" >
                            <a target="_blank" href={`/owners/new`}>
                                <Button type="button" variant="primary"
                                size="sm"
                                >Add</Button>
                                </a>
                            
                                
                                
                        </Col>
                    </Row>
                    {this.props.controlType==="table" && this.state.owners &&
                     <Row>
                        <Col><b>{this.state.owners.length} of {this.state.owners.length>0 ? this.state.owners[0].result_count: "0"} records returned.</b></Col>
                    </Row>
                    }
                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {this.state.isLoading &&
                    <div className="outer-div"><div className='sweet-loading inner-div' >
                        <PacmanLoader
                            css="display: block;
                            margin: 0 auto;
                             border-color: red"
                        sizeUnit={"px"}
                        size={20}
                        color={'#e03c31'}
                        loading={this.state.isLoading}
                        />
                </div>
                    </div>}
                        {!this.state.isLoading ? this.props.controlType == "table2" ? this.renderTable2(this.state.owners) : this.props.controlType == "table3" ? this.renderTable3(this.state.owners) : this.props.controlType == "table1" ? this.renderTable1(this.state.owners) :this.renderTable(this.state.owners) : this.renderTable([])  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="OwnerList">
            {this.props.isAuthenticated  ? this.renderOwners() : console.log("error)")}
            
        </div>
    );
  }
}
